import { Buildings, CaretRight } from '@phosphor-icons/react';

const PALETTE = ['#93C5FD', '#A3E635', '#FDE047', '#F9A8D4', '#FDBA74', '#C4B5FD', '#67E8F9', '#86EFAC'];

export const CompanyCards = ({ companies, selected, onSelect }) => {
  if (!companies.length) {
    return (
      <div className="bg-[#0F3622] border-2 border-dashed border-[#A3E635] rounded-md p-10 text-center text-white font-bold" data-testid="company-cards-empty">
        No lineups yet for this day. Add candidates manually or upload the morning Excel.
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="company-cards">
      {companies.map((c, i) => {
        const bg = PALETTE[i % PALETTE.length];
        const isActive = selected === c.company_name;
        return (
          <button
            key={c.company_name}
            data-testid={`company-card-${c.company_name}`}
            onClick={() => onSelect(isActive ? '' : c.company_name)}
            className={`text-left border-2 border-black rounded-md p-4 transition-all animate-in fade-in slide-in-from-bottom-2 ${isActive ? 'ring-4 ring-white -translate-y-1 shadow-[6px_6px_0px_0px_rgba(255,255,255,0.5)]' : 'shadow-[4px_4px_0px_0px_rgba(10,10,10,0.7)] hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_rgba(10,10,10,0.9)]'}`}
            style={{ backgroundColor: bg, animationDelay: `${i * 50}ms` }}
          >
            <div className="grid grid-cols-3 gap-1.5 mb-3" data-testid={`company-card-stats-${c.company_name}`}>
              <div className="bg-[#4ADE80] text-black border-2 border-black rounded-md px-1 py-1.5 text-center shadow-[2px_2px_0px_0px_rgba(10,10,10,1)]">
                <div className="text-xl font-black leading-none">{c.going}</div>
                <div className="text-[9px] font-black uppercase tracking-wider">Going</div>
              </div>
              <div className="bg-[#FDE047] text-black border-2 border-black rounded-md px-1 py-1.5 text-center shadow-[2px_2px_0px_0px_rgba(10,10,10,1)]">
                <div className="text-xl font-black leading-none">{c.pending}</div>
                <div className="text-[9px] font-black uppercase tracking-wider">Pending</div>
              </div>
              <div className="bg-[#F87171] text-white border-2 border-black rounded-md px-1 py-1.5 text-center shadow-[2px_2px_0px_0px_rgba(10,10,10,1)]">
                <div className="text-xl font-black leading-none">{c.not_going}</div>
                <div className="text-[9px] font-black uppercase tracking-wider">Not Going</div>
              </div>
            </div>
            <div className="flex items-start justify-between gap-2">
              <Buildings size={26} weight="duotone" className="text-black shrink-0" />
              <span className="text-3xl font-black text-black leading-none">{c.count}</span>
            </div>
            <div className="mt-2 font-black text-black text-base leading-tight truncate" title={c.company_name}>{c.company_name}</div>
            <div className="flex items-center text-[10px] font-bold uppercase tracking-wider text-black/70">
              {c.count} candidate{c.count === 1 ? '' : 's'}
              <CaretRight size={16} weight="bold" className="ml-auto text-black" />
            </div>
          </button>
        );
      })}
    </div>
  );
};
